import { useState } from 'react';
import {
  Card,
  CardContent,
  FormControlLabel,
  Stack,
  Switch,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import type { SessionEvent } from '@/types';
import LiveEventSummaryPanel from '@/components/live/LiveEventSummaryPanel';
import LiveEventVerticalTimeline from '@/components/live/LiveEventVerticalTimeline';
import { groupLiveEvents } from '@/components/live/liveEventStats';

type EventsTab = 'timeline' | 'summary';

interface Props {
  events: SessionEvent[];
  canEdit?: boolean;
  onEdit?: (event: SessionEvent) => void;
  onDelete?: (event: SessionEvent) => void;
}

export default function LiveEventsCard({ events, canEdit, onEdit, onDelete }: Props) {
  const [tab, setTab] = useState<EventsTab>('timeline');
  const [newestFirst, setNewestFirst] = useState(true);
  const markCount = groupLiveEvents(events).length;

  return (
    <Card variant="outlined">
      <CardContent sx={{ minWidth: 0 }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={1}
          sx={{ mb: 1 }}
        >
          <Typography variant="h6">事件列表</Typography>
          {tab === 'timeline' && (
            <FormControlLabel
              control={<Switch size="small" checked={newestFirst} onChange={(e) => setNewestFirst(e.target.checked)} />}
              label="最新優先"
              sx={{ mr: 0 }}
            />
          )}
        </Stack>

        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          variant="fullWidth"
          sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab value="timeline" label={`時間軸 (${markCount})`} />
          <Tab value="summary" label="統計摘要" />
        </Tabs>

        {tab === 'timeline' ? (
          <LiveEventVerticalTimeline
            events={events}
            canEdit={canEdit}
            newestFirst={newestFirst}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        ) : (
          <LiveEventSummaryPanel events={events} />
        )}
      </CardContent>
    </Card>
  );
}
